@for (position of ['top-right','top-center','top-left','bottom-right','bottom-left']; track position) {

<div class="toast-container" [attr.data-position]="position">

  @for (toast of getToastsByPosition(position); track toast.id) {

  <div class="toast" [attr.data-level]="toast.status" [ngStyle]="toast.customStyles || null" animate.enter="toast-in" animate.leave="toast-out">
    <div class="toast-content">
      <div class="toast-icon">
        @switch (toast.status) {
        @case ('success') {
        <mat-icon btn-icon-end svgIcon="icon-success-toast" class="success-icon"></mat-icon>
        }

        @case ('info') {
        <mat-icon btn-icon-end svgIcon="icon-info-circle" class="success-icon"></mat-icon>
        }

        @case ('warning') {

        <!-- Remove Later when SVG ICON was added in Sprite.svg -->
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 2L2 17h16L10 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M10 8v4M10 14h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        }

        @case ('error') {

        <!-- Remove Later when SVG ICON was added in Sprite.svg -->
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" />
          <path d="M13 7L7 13M7 7l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        }
        }
      </div>
      <div class="toast-message">{{ toast.message }}</div>
    </div>
    @if (toast.showClose) {
    <button class="toast-close" (click)="toaster.dismiss(toast.id)" aria-label="Close">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
    }
  </div>
  }
</div>
}